var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.33398 1.41016H6.00065C2.66732 1.41016 1.33398 2.82176 1.33398 6.35076V10.5856C1.33398 14.1146 2.66732 15.5262 6.00065 15.5262H10.0007C13.334 15.5262 14.6673 14.1146 14.6673 10.5856V9.17396",
    stroke: "#414141",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.6942 2.13161L5.44087 7.69331C5.21568 7.95483 5.06337 8.27733 5.00087 8.62497L4.7142 10.7494C4.67938 10.9146 4.68452 11.0864 4.72914 11.2489C4.77376 11.4114 4.85643 11.5594 4.96946 11.679C5.08249 11.7987 5.22224 11.8862 5.37574 11.9335C5.52924 11.9807 5.69152 11.9862 5.84754 11.9493L7.8542 11.6458C8.18161 11.5766 8.4855 11.4158 8.7342 11.18L13.9875 5.61826C14.8942 4.65837 15.3209 3.54321 13.9875 2.13161C12.6542 0.720008 11.6009 1.17172 10.6942 2.13161Z",
    stroke: "#414141",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M9.93945 2.92871C10.1605 3.75977 10.5794 4.51681 11.1561 5.12731C11.7327 5.73781 12.4478 6.18133 13.2328 6.41536",
    stroke: "#414141",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.239a4aee11acb1f70690d5ede3dcf868.svg";
export { ForwardRef as ReactComponent };